/**
 * Generates a key based on the current course used to determine if two
 * different objects can be considered as the same course
 */
function courseToSimilarityKey(course) {
  return `${course.id}-${course.title}-${course.levels.join(",")}-${course.subjects.join(",")}-${course.blocks?.map(blockToKey)}`;
}
function blockToKey(block) {
  return `${block.id}-${block.title}-${block.type}-${block.note.enabled}-${block.note.content}`;
}

export { courseToSimilarityKey };
//# sourceMappingURL=course-similarity.js.map
